"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreListGroup = _interopRequireDefault(require("@vfuk/core-list-group"));

var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));

var _coreBaseProps = require("@vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/PrimaryNav.style"));

var _constants = require("../../../../constants");

var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));

var _registerAriaTree = _interopRequireDefault(require("../../../../helpers/registerAriaTree"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PrimaryNav = function PrimaryNav(_ref) {
  var dataSelectorPrefix = _ref.dataSelectorPrefix;

  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
      primaryNav = _ref2.primaryNav,
      navLevel = _ref2.navLevel,
      setNavLevel = _ref2.setNavLevel,
      setActiveNav = _ref2.setActiveNav,
      animationDuration = _ref2.animationDuration,
      setNavTree = _ref2.setNavTree,
      interactionHandler = _ref2.interactionHandler,
      appearance = _ref2.appearance,
      topNavigationTheme = _ref2.topNavigationTheme;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      activeLink = _useState2[0],
      setActiveLink = _useState2[1];

  var clickHandler = function clickHandler(link, event) {
    var _getDataSelector, _link$onClick;

    interactionHandler(event, (_getDataSelector = (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, link.id)) !== null && _getDataSelector !== void 0 ? _getDataSelector : '');

    if (link.links) {
      setNavLevel(1);
      setActiveNav({
        parentId: link.id,
        links: link.links
      });
      setActiveLink(link.id);
      setNavTree([{
        level: 1,
        links: link.links,
        parentId: link.id
      }]);
      return;
    }

    (_link$onClick = link.onClick) === null || _link$onClick === void 0 ? void 0 : _link$onClick.call(link);
  };

  var numberBadgeAppearance = topNavigationTheme.appearance[appearance].mainBar.numberBadgeAppearance;
  return /*#__PURE__*/_react["default"].createElement(Styled.PrimaryNav, {
    "aria-label": primaryNav.srText,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(_coreListGroup["default"], null, primaryNav.links.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(Styled.PrimaryNavItem, {
      key: link.id,
      text: link.text
    }, /*#__PURE__*/_react["default"].createElement(Styled.PrimaryNavLink, {
      selected: navLevel > 0 && activeLink === link.id,
      id: link.id,
      label: link.srText,
      href: link.href,
      text: link.text,
      customRouterProps: link.customRouterProps,
      onClick: function onClick(event) {
        return clickHandler(link, event);
      },
      dataAttributes: (0, _registerAriaTree["default"])(link),
      "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(_constants.DataKeys.PrimaryNav, "-").concat(link.id)),
      animationDuration: animationDuration,
      appearance: appearance,
      topNavigationTheme: topNavigationTheme
    }, link.text), link.numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
      number: link.numberBadge,
      appearance: numberBadgeAppearance,
      "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(_constants.DataKeys.PrimaryNav, "-badge-").concat(link.id))
    })));
  })));
};

PrimaryNav.displayName = "PrimaryNav";
var _default = PrimaryNav;
exports["default"] = _default;
//# sourceMappingURL=PrimaryNav.js.map